import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* updateLookbookPublished({ payload: { id, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.updatePublishedPatch, id, data: values });

    onSuccess && onSuccess();
    yield put(actions.updateLookbookPublishedDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.updateLookbookPublishedFailed,
      handledErrors,
      endpoint: api.lookbooks.updatePublishedPatch.url
    });
  }
}

export const updateLookbookPublishedSaga = takeEvery(types.UPDATE_LOOKBOOK_PUBLISHED_REQUEST, updateLookbookPublished);